// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__nyxwR","content":"Layout_content__fwmv4","pageTitle":"Layout_pageTitle__O2kjj"};